import { useContractPlanDetailHeader } from './hooks';
import { convertToPresentationProps } from './logics';
import { ContractPlanDetailHeaderPresentation } from './presentations';

type Props = {
  /** 契約プラン ID */
  planId: number;
};

/**
 * 契約プラン詳細ヘッダー Container コンポーネント
 *
 * API から取得した契約プラン名を breadcrumb 付きページヘッダーに表示する。
 *
 * @param planId - 契約プラン ID（Screen 層でパース・検証済みの数値）
 */
export const ContractPlanDetailHeader: React.FC<Props> = ({ planId }) => {
  const {
    state: { contractPlan },
  } = useContractPlanDetailHeader({ planId });

  const { breadcrumbItems } = convertToPresentationProps({
    contractPlan: contractPlan.contract_plan,
  });

  return <ContractPlanDetailHeaderPresentation breadcrumbItems={breadcrumbItems} />;
};
